import { Card, Empty, Typography } from "antd";
import React from "react";
import {
  CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryActivityLogFieldsFragment,
  CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFieldsFragment,
  CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsFieldsFragment,
  CasesCredentialVerificationCaseSummaryContainerFileInfoFieldsFragment,
  FileInfo,
} from "../../../../../../generated";
import { Country } from "../../../../../../types/country";
import {
  TransactionData,
  TransactionsLite,
} from "../../../../../shared/transactions/transactions-lite";
import { AffirmationsSummary } from "./affirmations-summary";
import { PrivateCaseDetailsSummary } from "./private-case-details-summary";
import { FilesSummary } from "../../../../../shared/display-files/files-summary";
import { ApplicantDetailsSummary } from "./applicant-details-summary";
import { ActivityLogLite } from "../../../../../shared/activitylog-lite/activity-log-lite";
import { AdditionalFilesSummary } from "./additional-files-summary";

interface SummaryProps {
  caseDetailsData: CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsFieldsFragment;
  fileDetails: CasesCredentialVerificationCaseSummaryContainerFileInfoFieldsFragment[];
  privateCaseDetails: CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFieldsFragment;
  countryData: Country[];
  transactionData: TransactionData;
  activityData: CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryActivityLogFieldsFragment[];
  additionalFiles: FileInfo[];
}

export const Summary: React.FC<SummaryProps> = (props) => {
  return (
    <div className="flex flex-col space-y-4">
      <div>
        <ApplicantDetailsSummary
          applicationDetails={props.caseDetailsData?.application}
        />
        <br />
        <PrivateCaseDetailsSummary
          privateCaseDetails={props.privateCaseDetails}
          caseDetailsData={props.caseDetailsData}
        />
        <br />
        <FilesSummary fileDetails={props.fileDetails} />
        <br />
        <Card>
          <div className="flex flex-col space-y-4">
            {props.additionalFiles.length > 0 ? (
              props.additionalFiles.map((file) => (
                <AdditionalFilesSummary
                  key={file.name}
                  fileName={file.name}
                  fileUrl={file.url}
                />
              ))
            ) : (
              <Empty description="No additional files found." />
            )}
          </div>
        </Card>
        <br />
        <AffirmationsSummary
          caseApplicationReviewData={props.caseDetailsData?.applicationReview}
        />
        <div className="flex space-x-48 w-1/2"></div>
        <br />
        <Card>
        <Typography.Text style={{ fontSize: '20px' }}>Transaction Summary</Typography.Text>
          <TransactionsLite data={props.transactionData} />
          <br />
          <Typography.Text style={{ fontSize: '20px' }}>Activity Log</Typography.Text>
          <ActivityLogLite data={props.activityData} />
        </Card>
      </div>
    </div>
  );
};
